export const translations = {
  en: {
    // Navigation
    nav: {
      dashboard: "Dashboard",
      supportQueue: "Support Queue",
      workOrders: "Work Orders",
      fieldService: "Field Service",
      slaContracts: "SLA Contracts",
      timeTracking: "Time Tracking",
      serviceCatalog: "Service Catalog",
      earnings: "Earnings",
      products: "Products",
      userManagement: "User Management",
      quickbooks: "QuickBooks",
      myTickets: "My Tickets",
      services: "Services",
      paymentHistory: "Payment History",
      myEarnings: "My Earnings",
      myJobs: "My Jobs",
      invoices: "Invoices",
      myInvoices: "My Invoices",
    },
    // Common
    common: {
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      submit: "Submit",
      close: "Close",
      back: "Back",
      loading: "Loading...",
      search: "Search",
      filter: "Filter",
      actions: "Actions",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      yes: "Yes",
      no: "No",
      confirm: "Confirm",
      signOut: "Sign Out",
      myAccount: "My Account",
      welcome: "Welcome",
      noData: "No data available",
      viewAll: "View All",
      add: "Add",
      update: "Update",
      details: "Details",
      description: "Description",
      name: "Name",
      email: "Email",
      role: "Role",
      date: "Date",
      amount: "Amount",
      total: "Total",
      price: "Price",
      type: "Type",
      product: "Product",
      all: "All",
      none: "None",
      required: "Required",
      optional: "Optional",
      language: "Language",
    },
    // Auth
    auth: {
      login: "Sign In",
      register: "Sign Up",
      email: "Email Address",
      password: "Password",
      fullName: "Full Name",
      loginTitle: "Welcome Back",
      loginSubtitle: "Sign in to your SAG Helpdesk account",
      registerTitle: "Create Account",
      registerSubtitle: "Join the SAG Helpdesk platform",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      signingIn: "Signing in...",
      creatingAccount: "Creating account...",
    },
    // Tickets
    tickets: {
      title: "Tickets",
      newTicket: "New Ticket",
      createTicket: "Create Ticket",
      ticketDetail: "Ticket Detail",
      yourTickets: "Your Tickets",
      viewManage: "View and manage your support requests",
      conversation: "Conversation",
      noMessages: "No messages yet. Start the conversation!",
      typeMessage: "Type your message...",
      sendMessage: "Send",
      priority: "Priority",
      assignedTo: "Assigned To",
      unassigned: "Unassigned",
      client: "Client",
      category: "Category",
      created: "Created",
      lastUpdated: "Last Updated",
      translate: "Translate",
      translating: "Translating...",
      translated: "Translated",
      showOriginal: "Show Original",
      rateExperience: "Rate Your Experience",
      submitReview: "Submit Review",
      submittingReview: "Submitting...",
      reviewSubmitted: "Review submitted! Thank you.",
      shareExperience: "Share your experience (optional)...",
      selectRating: "Please select a rating",
      submitted: "Submitted",
      // Status
      statusOpen: "Open",
      statusInProgress: "In Progress",
      statusPendingClient: "Awaiting Response",
      statusResolved: "Resolved",
      statusClosed: "Closed",
      // Priority
      priorityLow: "Low",
      priorityMedium: "Medium",
      priorityHigh: "High",
      priorityUrgent: "Urgent",
    },
    // Dashboard
    dashboard: {
      welcomeBack: "Welcome back,",
      manageTickets: "Manage your support tickets and service requests",
      totalTickets: "Total Tickets",
      openTickets: "Open Tickets",
      resolved: "Resolved",
      emailSupport: "Email Support Available",
      emailSupportDesc: "You can also create tickets by emailing our support addresses directly. Replies to ticket confirmation emails will automatically update your ticket.",
      assignedTickets: "Assigned Tickets",
      inProgress: "In Progress",
      avgResponse: "Avg Response",
      todaysJobs: "Today's Jobs",
      completedJobs: "Completed",
      activeJobs: "Active Jobs",
      pendingDispatch: "Pending Dispatch",
    },
    // Services
    services: {
      title: "Support Services",
      subtitle: "Select a service and pay to get immediate expert assistance",
      serviceCatalog: "Service Catalog",
      manageServices: "Manage service offerings and pricing",
      addService: "Add Service",
      editService: "Edit Service",
      createService: "Create Service",
      serviceName: "Service Name",
      serviceNamePlaceholder: "e.g., Website Troubleshooting",
      serviceDescription: "What does this service include...",
      pricingType: "Pricing Type",
      hourlyRate: "Hourly Rate",
      fixedPrice: "Fixed Price",
      priceUsd: "Price (USD)",
      estimatedHours: "Estimated Hours",
      noServices: "No services available at this time.",
      noServicesAdmin: "No services yet. Add your first service offering!",
      getStarted: "Get Started",
      confirmPay: "Confirm & Pay",
      hoursNeeded: "How many hours do you need?",
      totalDue: "Total Due",
      payNow: "Pay Now",
      processing: "Processing...",
      paymentSecure: "Your payment is processed securely. A consultant will be assigned immediately upon payment confirmation.",
      hourly: "Hourly",
      fixed: "Fixed",
      perHour: "/hour",
      allProducts: "All Products",
    },
    // Earnings
    earnings: {
      revenueEarnings: "Revenue & Earnings",
      myEarnings: "My Earnings",
      platformRevenue: "Platform revenue, payouts, and transaction history",
      yourEarnings: "Your earnings and payment history",
      totalRevenue: "Total Revenue",
      sagRevenue: "SAG Revenue (60%)",
      consultantPayouts: "Consultant Payouts (40%)",
      transactions: "Transactions",
      totalEarned: "Total Earned",
      pendingPayout: "Pending Payout",
      jobsCompleted: "Jobs Completed",
      consultantEarnings: "Consultant Earnings",
      byPaymentProcessor: "By Payment Processor",
      transactionHistory: "Transaction History",
      noTransactions: "No transactions yet",
      service: "Service",
      processor: "Processor",
      yourShare: "Your Share",
      consultant40: "Consultant (40%)",
      sag60: "SAG (60%)",
    },
    // Users
    users: {
      title: "User Management",
      subtitle: "Manage platform users and permissions",
      inviteUser: "Invite User",
      editUser: "Edit User",
      deleteUser: "Delete User",
      deleteConfirm: "Are you sure you want to delete this user?",
      admin: "Admin",
      consultant: "Consultant",
      fieldAgent: "Field Agent",
      clientRole: "Client",
    },
    // Work Orders
    workOrders: {
      title: "Work Orders",
      subtitle: "Manage and dispatch field service jobs",
      createWorkOrder: "Create Work Order",
      status: {
        pending: "Pending",
        dispatched: "Dispatched",
        enRoute: "En Route",
        onSite: "On Site",
        completed: "Completed",
      },
    },
    // SLA
    sla: {
      title: "SLA Contracts",
      subtitle: "Manage client service level agreements",
      createContract: "Create Contract",
      totalHours: "Total Hours",
      usedHours: "Used Hours",
      remainingHours: "Remaining Hours",
      billingPeriod: "Billing Period",
      exceeded: "Exceeded",
      consumed: "consumed",
      overageWarning: "You have exceeded your allocated SLA hours. Additional work will be billed accordingly.",
      nearLimitWarning: "You are approaching your SLA hour limit. Please plan accordingly.",
      viewEntries: "View time entries",
      hideEntries: "Hide time entries",
      adHocTitle: "Pay-Per-Service Client",
      adHocDesc: "You are billed per service request. Browse our Service Catalog to purchase support packages or submit individual tickets as needed.",
      clientType: "Client Type",
      slaClient: "SLA Client",
      adHocClient: "Ad Hoc Client",
    },
    // Time Tracking
    timeTracking: {
      title: "Time Tracking",
      subtitle: "Log and manage consultant work hours",
      addEntry: "Add Time Entry",
      startTimer: "Start Timer",
      stopTimer: "Stop Timer",
      hours: "Hours",
      ticket: "Ticket",
    },
    // Products
    products: {
      title: "Product Management",
      subtitle: "Manage SAG digital products and support channels",
      addProduct: "Add Product",
      domain: "Domain",
      supportEmail: "Support Email",
      registeredProducts: "Registered Products",
      digitalProducts: "Digital products under Sebastian Alliance Group",
      emailToTicketSetup: "Email-to-Ticket Setup",
      emailToTicketDesc: "To enable automatic ticket creation from emails, configure SendGrid Inbound Parse for each product domain. Use the webhook URL below and set up MX records as per SendGrid documentation.",
    },
    // Payment
    payment: {
      processingPayment: "Processing Payment...",
      pleaseWait: "Please wait while we confirm your payment.",
      paymentSuccessful: "Payment Successful!",
      consultantAssigned: "A consultant has been assigned and will reach out to you shortly.",
      ticketReference: "Your Ticket Reference",
      goToTicket: "Go to Ticket",
      backToDashboard: "Back to Dashboard",
      paymentFailed: "Payment Failed",
      paymentFailedDesc: "Your payment could not be processed. Please try again.",
      tryAgain: "Try Again",
      stillProcessing: "Still Processing",
      takingLonger: "Your payment is taking longer than usual. Check your email for confirmation.",
    },
    // Video/Remote
    video: {
      videoCall: "Video Call",
      remoteAccess: "Remote Access",
      startVideoCall: "Start Video Call",
      startRemoteSession: "Start Remote Session",
    },
    // Contractor Agreement
    contractor: {
      agreementTitle: "Contractor Agreement",
      mustAccept: "You must accept the contractor agreement before accessing the platform.",
      accept: "Accept Agreement",
    },
  },

  es: {
    nav: {
      dashboard: "Panel",
      supportQueue: "Cola de Soporte",
      workOrders: "Ordenes de Trabajo",
      fieldService: "Servicio de Campo",
      slaContracts: "Contratos SLA",
      timeTracking: "Control de Horas",
      serviceCatalog: "Catalogo de Servicios",
      earnings: "Ingresos",
      products: "Productos",
      userManagement: "Gestion de Usuarios",
      quickbooks: "QuickBooks",
      myTickets: "Mis Tickets",
      services: "Servicios",
      paymentHistory: "Historial de Pagos",
      myEarnings: "Mis Ingresos",
      myJobs: "Mis Trabajos",
      invoices: "Facturas",
      myInvoices: "Mis Facturas",
    },    common: {
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      create: "Crear",
      submit: "Enviar",
      close: "Cerrar",
      back: "Volver",
      loading: "Cargando...",
      search: "Buscar",
      filter: "Filtrar",
      actions: "Acciones",
      status: "Estado",
      active: "Activo",
      inactive: "Inactivo",
      yes: "Si",
      no: "No",
      confirm: "Confirmar",
      signOut: "Cerrar Sesion",
      myAccount: "Mi Cuenta",
      welcome: "Bienvenido",
      noData: "No hay datos disponibles",
      viewAll: "Ver Todo",
      add: "Agregar",
      update: "Actualizar",
      details: "Detalles",
      description: "Descripcion",
      name: "Nombre",
      email: "Correo",
      role: "Rol",
      date: "Fecha",
      amount: "Monto",
      total: "Total",
      price: "Precio",
      type: "Tipo",
      product: "Producto",
      all: "Todos",
      none: "Ninguno",
      required: "Requerido",
      optional: "Opcional",
      language: "Idioma",
    },
    auth: {
      login: "Iniciar Sesion",
      register: "Registrarse",
      email: "Correo Electronico",
      password: "Contrasena",
      fullName: "Nombre Completo",
      loginTitle: "Bienvenido de Nuevo",
      loginSubtitle: "Inicia sesion en tu cuenta de SAG Helpdesk",
      registerTitle: "Crear Cuenta",
      registerSubtitle: "Unete a la plataforma SAG Helpdesk",
      noAccount: "No tienes una cuenta?",
      hasAccount: "Ya tienes una cuenta?",
      signingIn: "Iniciando sesion...",
      creatingAccount: "Creando cuenta...",
    },
    tickets: {
      title: "Tickets",
      newTicket: "Nuevo Ticket",
      createTicket: "Crear Ticket",
      ticketDetail: "Detalle del Ticket",
      yourTickets: "Tus Tickets",
      viewManage: "Ver y gestionar tus solicitudes de soporte",
      conversation: "Conversacion",
      noMessages: "Aun no hay mensajes. Inicia la conversacion!",
      typeMessage: "Escribe tu mensaje...",
      sendMessage: "Enviar",
      priority: "Prioridad",
      assignedTo: "Asignado a",
      unassigned: "Sin Asignar",
      client: "Cliente",
      category: "Categoria",
      created: "Creado",
      lastUpdated: "Ultima Actualizacion",
      translate: "Traducir",
      translating: "Traduciendo...",
      translated: "Traducido",
      showOriginal: "Mostrar Original",
      rateExperience: "Califica tu Experiencia",
      submitReview: "Enviar Resena",
      submittingReview: "Enviando...",
      reviewSubmitted: "Resena enviada! Gracias.",
      shareExperience: "Comparte tu experiencia (opcional)...",
      selectRating: "Por favor selecciona una calificacion",
      submitted: "Enviado",
      statusOpen: "Abierto",
      statusInProgress: "En Progreso",
      statusPendingClient: "Esperando Respuesta",
      statusResolved: "Resuelto",
      statusClosed: "Cerrado",
      priorityLow: "Baja",
      priorityMedium: "Media",
      priorityHigh: "Alta",
      priorityUrgent: "Urgente",
    },
    dashboard: {
      welcomeBack: "Bienvenido de nuevo,",
      manageTickets: "Gestiona tus tickets de soporte y solicitudes de servicio",
      totalTickets: "Total de Tickets",
      openTickets: "Tickets Abiertos",
      resolved: "Resueltos",
      emailSupport: "Soporte por Correo Disponible",
      emailSupportDesc: "Tambien puedes crear tickets enviando un correo a nuestras direcciones de soporte. Las respuestas a los correos de confirmacion actualizaran automaticamente tu ticket.",
      assignedTickets: "Tickets Asignados",
      inProgress: "En Progreso",
      avgResponse: "Resp. Promedio",
      todaysJobs: "Trabajos de Hoy",
      completedJobs: "Completados",
      activeJobs: "Trabajos Activos",
      pendingDispatch: "Pendientes de Despacho",
    },
    services: {
      title: "Servicios de Soporte",
      subtitle: "Selecciona un servicio y paga para obtener asistencia experta inmediata",
      serviceCatalog: "Catalogo de Servicios",
      manageServices: "Gestionar ofertas de servicios y precios",
      addService: "Agregar Servicio",
      editService: "Editar Servicio",
      createService: "Crear Servicio",
      serviceName: "Nombre del Servicio",
      serviceNamePlaceholder: "ej., Solucion de Problemas Web",
      serviceDescription: "Que incluye este servicio...",
      pricingType: "Tipo de Precio",
      hourlyRate: "Tarifa por Hora",
      fixedPrice: "Precio Fijo",
      priceUsd: "Precio (USD)",
      estimatedHours: "Horas Estimadas",
      noServices: "No hay servicios disponibles en este momento.",
      noServicesAdmin: "Aun no hay servicios. Agrega tu primera oferta!",
      getStarted: "Comenzar",
      confirmPay: "Confirmar y Pagar",
      hoursNeeded: "Cuantas horas necesitas?",
      totalDue: "Total a Pagar",
      payNow: "Pagar Ahora",
      processing: "Procesando...",
      paymentSecure: "Tu pago se procesa de forma segura. Un consultor sera asignado inmediatamente al confirmar el pago.",
      hourly: "Por Hora",
      fixed: "Fijo",
      perHour: "/hora",
      allProducts: "Todos los Productos",
    },
    earnings: {
      revenueEarnings: "Ingresos y Ganancias",
      myEarnings: "Mis Ingresos",
      platformRevenue: "Ingresos de la plataforma, pagos y historial de transacciones",
      yourEarnings: "Tus ingresos e historial de pagos",
      totalRevenue: "Ingresos Totales",
      sagRevenue: "Ingresos SAG (60%)",
      consultantPayouts: "Pagos a Consultores (40%)",
      transactions: "Transacciones",
      totalEarned: "Total Ganado",
      pendingPayout: "Pago Pendiente",
      jobsCompleted: "Trabajos Completados",
      consultantEarnings: "Ganancias de Consultores",
      byPaymentProcessor: "Por Procesador de Pago",
      transactionHistory: "Historial de Transacciones",
      noTransactions: "Aun no hay transacciones",
      service: "Servicio",
      processor: "Procesador",
      yourShare: "Tu Parte",
      consultant40: "Consultor (40%)",
      sag60: "SAG (60%)",
    },
    users: {
      title: "Gestion de Usuarios",
      subtitle: "Gestionar usuarios y permisos de la plataforma",
      inviteUser: "Invitar Usuario",
      editUser: "Editar Usuario",
      deleteUser: "Eliminar Usuario",
      deleteConfirm: "Estas seguro de que deseas eliminar este usuario?",
      admin: "Administrador",
      consultant: "Consultor",
      fieldAgent: "Agente de Campo",
      clientRole: "Cliente",
    },
    workOrders: {
      title: "Ordenes de Trabajo",
      subtitle: "Gestionar y despachar trabajos de servicio de campo",
      createWorkOrder: "Crear Orden de Trabajo",
      status: {
        pending: "Pendiente",
        dispatched: "Despachado",
        enRoute: "En Camino",
        onSite: "En Sitio",
        completed: "Completado",
      },
    },
    sla: {
      title: "Contratos SLA",
      subtitle: "Gestionar acuerdos de nivel de servicio",
      createContract: "Crear Contrato",
      totalHours: "Horas Totales",
      usedHours: "Horas Usadas",
      remainingHours: "Horas Restantes",
      billingPeriod: "Periodo de Facturacion",
      exceeded: "Excedido",
      consumed: "consumido",
      overageWarning: "Has excedido tus horas SLA asignadas. El trabajo adicional sera facturado.",
      nearLimitWarning: "Te acercas al limite de tus horas SLA. Planifica en consecuencia.",
      viewEntries: "Ver entradas de tiempo",
      hideEntries: "Ocultar entradas de tiempo",
      adHocTitle: "Cliente Pago por Servicio",
      adHocDesc: "Se te factura por solicitud de servicio. Explora nuestro Catalogo de Servicios para comprar paquetes de soporte o enviar tickets individuales.",
      clientType: "Tipo de Cliente",
      slaClient: "Cliente SLA",
      adHocClient: "Cliente Ad Hoc",
    },
    timeTracking: {
      title: "Control de Horas",
      subtitle: "Registrar y gestionar horas de trabajo",
      addEntry: "Agregar Entrada",
      startTimer: "Iniciar Temporizador",
      stopTimer: "Detener Temporizador",
      hours: "Horas",
      ticket: "Ticket",
    },
    products: {
      title: "Gestion de Productos",
      subtitle: "Gestionar productos digitales y canales de soporte de SAG",
      addProduct: "Agregar Producto",
      domain: "Dominio",
      supportEmail: "Correo de Soporte",
      registeredProducts: "Productos Registrados",
      digitalProducts: "Productos digitales bajo Sebastian Alliance Group",
      emailToTicketSetup: "Configuracion Email-a-Ticket",
      emailToTicketDesc: "Para habilitar la creacion automatica de tickets desde correos, configura SendGrid Inbound Parse para cada dominio de producto.",
    },
    payment: {
      processingPayment: "Procesando Pago...",
      pleaseWait: "Por favor espera mientras confirmamos tu pago.",
      paymentSuccessful: "Pago Exitoso!",
      consultantAssigned: "Un consultor ha sido asignado y se comunicara contigo en breve.",
      ticketReference: "Referencia de tu Ticket",
      goToTicket: "Ir al Ticket",
      backToDashboard: "Volver al Panel",
      paymentFailed: "Pago Fallido",
      paymentFailedDesc: "No se pudo procesar tu pago. Por favor intenta de nuevo.",
      tryAgain: "Intentar de Nuevo",
      stillProcessing: "Aun Procesando",
      takingLonger: "Tu pago esta tardando mas de lo usual. Revisa tu correo para la confirmacion.",
    },
    video: {
      videoCall: "Videollamada",
      remoteAccess: "Acceso Remoto",
      startVideoCall: "Iniciar Videollamada",
      startRemoteSession: "Iniciar Sesion Remota",
    },
    contractor: {
      agreementTitle: "Acuerdo de Contratista",
      mustAccept: "Debes aceptar el acuerdo de contratista antes de acceder a la plataforma.",
      accept: "Aceptar Acuerdo",
    },
  },

  fr: {
    nav: {
      dashboard: "Tableau de Bord",
      supportQueue: "File de Support",
      workOrders: "Ordres de Travail",
      fieldService: "Service Terrain",
      slaContracts: "Contrats SLA",
      timeTracking: "Suivi du Temps",
      serviceCatalog: "Catalogue de Services",
      earnings: "Revenus",
      products: "Produits",
      userManagement: "Gestion des Utilisateurs",
      quickbooks: "QuickBooks",
      myTickets: "Mes Tickets",
      services: "Services",
      paymentHistory: "Historique des Paiements",
      myEarnings: "Mes Revenus",
      myJobs: "Mes Missions",
      invoices: "Factures",
      myInvoices: "Mes Factures",
    },    common: {
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      create: "Creer",
      submit: "Soumettre",
      close: "Fermer",
      back: "Retour",
      loading: "Chargement...",
      search: "Rechercher",
      filter: "Filtrer",
      actions: "Actions",
      status: "Statut",
      active: "Actif",
      inactive: "Inactif",
      yes: "Oui",
      no: "Non",
      confirm: "Confirmer",
      signOut: "Deconnexion",
      myAccount: "Mon Compte",
      welcome: "Bienvenue",
      noData: "Aucune donnee disponible",
      viewAll: "Voir Tout",
      add: "Ajouter",
      update: "Mettre a jour",
      details: "Details",
      description: "Description",
      name: "Nom",
      email: "Email",
      role: "Role",
      date: "Date",
      amount: "Montant",
      total: "Total",
      price: "Prix",
      type: "Type",
      product: "Produit",
      all: "Tous",
      none: "Aucun",
      required: "Requis",
      optional: "Optionnel",
      language: "Langue",
    },
    auth: {
      login: "Se Connecter",
      register: "S'inscrire",
      email: "Adresse Email",
      password: "Mot de Passe",
      fullName: "Nom Complet",
      loginTitle: "Bon Retour",
      loginSubtitle: "Connectez-vous a votre compte SAG Helpdesk",
      registerTitle: "Creer un Compte",
      registerSubtitle: "Rejoignez la plateforme SAG Helpdesk",
      noAccount: "Vous n'avez pas de compte?",
      hasAccount: "Vous avez deja un compte?",
      signingIn: "Connexion en cours...",
      creatingAccount: "Creation du compte...",
    },
    tickets: {
      title: "Tickets",
      newTicket: "Nouveau Ticket",
      createTicket: "Creer un Ticket",
      ticketDetail: "Detail du Ticket",
      yourTickets: "Vos Tickets",
      viewManage: "Voir et gerer vos demandes de support",
      conversation: "Conversation",
      noMessages: "Pas encore de messages. Commencez la conversation!",
      typeMessage: "Tapez votre message...",
      sendMessage: "Envoyer",
      priority: "Priorite",
      assignedTo: "Assigne a",
      unassigned: "Non Assigne",
      client: "Client",
      category: "Categorie",
      created: "Cree",
      lastUpdated: "Derniere Mise a Jour",
      translate: "Traduire",
      translating: "Traduction...",
      translated: "Traduit",
      showOriginal: "Afficher l'Original",
      rateExperience: "Evaluez votre Experience",
      submitReview: "Soumettre l'Avis",
      submittingReview: "Envoi en cours...",
      reviewSubmitted: "Avis soumis! Merci.",
      shareExperience: "Partagez votre experience (optionnel)...",
      selectRating: "Veuillez selectionner une note",
      submitted: "Soumis",
      statusOpen: "Ouvert",
      statusInProgress: "En Cours",
      statusPendingClient: "En Attente de Reponse",
      statusResolved: "Resolu",
      statusClosed: "Ferme",
      priorityLow: "Basse",
      priorityMedium: "Moyenne",
      priorityHigh: "Haute",
      priorityUrgent: "Urgente",
    },
    dashboard: {
      welcomeBack: "Bon retour,",
      manageTickets: "Gerez vos tickets de support et demandes de service",
      totalTickets: "Total des Tickets",
      openTickets: "Tickets Ouverts",
      resolved: "Resolus",
      emailSupport: "Support par Email Disponible",
      emailSupportDesc: "Vous pouvez aussi creer des tickets en envoyant un email a nos adresses de support. Les reponses aux emails de confirmation mettront automatiquement a jour votre ticket.",
      assignedTickets: "Tickets Assignes",
      inProgress: "En Cours",
      avgResponse: "Rep. Moyenne",
      todaysJobs: "Missions du Jour",
      completedJobs: "Terminees",
      activeJobs: "Missions Actives",
      pendingDispatch: "En Attente d'Envoi",
    },
    services: {
      title: "Services de Support",
      subtitle: "Selectionnez un service et payez pour obtenir une assistance experte immediate",
      serviceCatalog: "Catalogue de Services",
      manageServices: "Gerer les offres de services et les tarifs",
      addService: "Ajouter un Service",
      editService: "Modifier le Service",
      createService: "Creer un Service",
      serviceName: "Nom du Service",
      serviceNamePlaceholder: "ex., Depannage de Site Web",
      serviceDescription: "Que comprend ce service...",
      pricingType: "Type de Tarification",
      hourlyRate: "Tarif Horaire",
      fixedPrice: "Prix Fixe",
      priceUsd: "Prix (USD)",
      estimatedHours: "Heures Estimees",
      noServices: "Aucun service disponible pour le moment.",
      noServicesAdmin: "Pas encore de services. Ajoutez votre premiere offre!",
      getStarted: "Commencer",
      confirmPay: "Confirmer et Payer",
      hoursNeeded: "Combien d'heures avez-vous besoin?",
      totalDue: "Total a Payer",
      payNow: "Payer Maintenant",
      processing: "Traitement...",
      paymentSecure: "Votre paiement est traite en toute securite. Un consultant sera assigne immediatement apres confirmation du paiement.",
      hourly: "Horaire",
      fixed: "Fixe",
      perHour: "/heure",
      allProducts: "Tous les Produits",
    },
    earnings: {
      revenueEarnings: "Revenus et Gains",
      myEarnings: "Mes Revenus",
      platformRevenue: "Revenus de la plateforme, versements et historique des transactions",
      yourEarnings: "Vos revenus et historique de paiements",
      totalRevenue: "Revenus Totaux",
      sagRevenue: "Revenus SAG (60%)",
      consultantPayouts: "Versements Consultants (40%)",
      transactions: "Transactions",
      totalEarned: "Total Gagne",
      pendingPayout: "Versement en Attente",
      jobsCompleted: "Missions Terminees",
      consultantEarnings: "Gains des Consultants",
      byPaymentProcessor: "Par Processeur de Paiement",
      transactionHistory: "Historique des Transactions",
      noTransactions: "Pas encore de transactions",
      service: "Service",
      processor: "Processeur",
      yourShare: "Votre Part",
      consultant40: "Consultant (40%)",
      sag60: "SAG (60%)",
    },
    users: {
      title: "Gestion des Utilisateurs",
      subtitle: "Gerer les utilisateurs et les permissions de la plateforme",
      inviteUser: "Inviter un Utilisateur",
      editUser: "Modifier l'Utilisateur",
      deleteUser: "Supprimer l'Utilisateur",
      deleteConfirm: "Etes-vous sur de vouloir supprimer cet utilisateur?",
      admin: "Administrateur",
      consultant: "Consultant",
      fieldAgent: "Agent de Terrain",
      clientRole: "Client",
    },
    workOrders: {
      title: "Ordres de Travail",
      subtitle: "Gerer et dispatcher les missions de service terrain",
      createWorkOrder: "Creer un Ordre de Travail",
      status: {
        pending: "En Attente",
        dispatched: "Dispatche",
        enRoute: "En Route",
        onSite: "Sur Place",
        completed: "Termine",
      },
    },
    sla: {
      title: "Contrats SLA",
      subtitle: "Gerer les accords de niveau de service",
      createContract: "Creer un Contrat",
      totalHours: "Heures Totales",
      usedHours: "Heures Utilisees",
      remainingHours: "Heures Restantes",
      billingPeriod: "Periode de Facturation",
      exceeded: "Depasse",
      consumed: "consomme",
      overageWarning: "Vous avez depasse vos heures SLA allouees. Le travail supplementaire sera facture.",
      nearLimitWarning: "Vous approchez de la limite de vos heures SLA. Planifiez en consequence.",
      viewEntries: "Voir les entrees de temps",
      hideEntries: "Masquer les entrees de temps",
      adHocTitle: "Client Paiement par Service",
      adHocDesc: "Vous etes facture par demande de service. Parcourez notre Catalogue de Services pour acheter des forfaits ou soumettre des tickets individuels.",
      clientType: "Type de Client",
      slaClient: "Client SLA",
      adHocClient: "Client Ad Hoc",
    },
    timeTracking: {
      title: "Suivi du Temps",
      subtitle: "Enregistrer et gerer les heures de travail",
      addEntry: "Ajouter une Entree",
      startTimer: "Demarrer le Chronometre",
      stopTimer: "Arreter le Chronometre",
      hours: "Heures",
      ticket: "Ticket",
    },
    products: {
      title: "Gestion des Produits",
      subtitle: "Gerer les produits numeriques et les canaux de support SAG",
      addProduct: "Ajouter un Produit",
      domain: "Domaine",
      supportEmail: "Email de Support",
      registeredProducts: "Produits Enregistres",
      digitalProducts: "Produits numeriques sous Sebastian Alliance Group",
      emailToTicketSetup: "Configuration Email-vers-Ticket",
      emailToTicketDesc: "Pour activer la creation automatique de tickets a partir d'emails, configurez SendGrid Inbound Parse pour chaque domaine de produit.",
    },
    payment: {
      processingPayment: "Traitement du Paiement...",
      pleaseWait: "Veuillez patienter pendant que nous confirmons votre paiement.",
      paymentSuccessful: "Paiement Reussi!",
      consultantAssigned: "Un consultant a ete assigne et vous contactera sous peu.",
      ticketReference: "Reference de votre Ticket",
      goToTicket: "Aller au Ticket",
      backToDashboard: "Retour au Tableau de Bord",
      paymentFailed: "Paiement Echoue",
      paymentFailedDesc: "Votre paiement n'a pas pu etre traite. Veuillez reessayer.",
      tryAgain: "Reessayer",
      stillProcessing: "Toujours en Traitement",
      takingLonger: "Votre paiement prend plus de temps que prevu. Verifiez votre email pour la confirmation.",
    },
    video: {
      videoCall: "Appel Video",
      remoteAccess: "Acces a Distance",
      startVideoCall: "Demarrer l'Appel Video",
      startRemoteSession: "Demarrer la Session a Distance",
    },
    contractor: {
      agreementTitle: "Accord de Sous-traitant",
      mustAccept: "Vous devez accepter l'accord de sous-traitant avant d'acceder a la plateforme.",
      accept: "Accepter l'Accord",
    },
  },
};

export const languageNames = {
  en: "English",
  es: "Espanol",
  fr: "Francais",
};
